import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import GlobalCta from "../components/global/GlobalCta";
import FujairahTextImage from "../components/truck-rental-fujairah/FujairahTextImage";
import FujairahTextSection from "../components/truck-rental-fujairah/FujairahTextSection";
import FujairahFaq from "../components/truck-rental-fujairah/FujairahFaq";
import VanRentalTable from "../components/van-rental-dubai/VanRentalTable";

import { chillerVanAlBarshaSections } from "../components/chiller-van-al-barsha/chillerVanAlBarshaSections";
import "../components/truck-rental-fujairah/truck-rental-fujairah.css";
import "../components/van-rental-dubai/van-rental-dubai.css";
import "../components/chiller-van/chiller-van.css";

const ChillerVanForRentInAlBarsha = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "cvb-hero":
        return (
          <ContactHero
            key={index}
            variant="chiller-van"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cvb-text-image":
        return (
          <FujairahTextImage
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            reverse={section.reverse}
            altBg={section.altBg}
          />
        );

      case "cvb-text-only":
        return (
          <FujairahTextSection
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cvb-table":
        return (
          <VanRentalTable
            key={index}
            title={section.title}
            description={section.description}
            intro={section.intro}
            columns={section.columns}
            rows={section.rows}
            notes={section.notes}
            background={section.background}
          />
        );

      case "cvb-faq":
        return (
          <FujairahFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Chiller Van Rental in Al Barsha | From AED 250/Day | Chiller Fleet</title>
        <meta name="description" content="Chiller van rental in Al Barsha from our local branch — standard roof vans cleared for hotel basements and Mall of the Emirates loading bays. On site in 15 to 30 minutes." />
        <link rel="canonical" href="https://chillerfleet.com/chiller-van-for-rent-in-al-barsha" />
        <meta property="og:title" content="Chiller Van Rental in Al Barsha | From AED 250/Day | Chiller Fleet" />
        <meta property="og:description" content="Chiller van rental in Al Barsha from our local branch — standard roof vans cleared for hotel basements and Mall of the Emirates loading bays. On site in 15 to 30 minutes." />
        <meta property="og:url" content="https://chillerfleet.com/chiller-van-for-rent-in-al-barsha" />
        <meta name="twitter:title" content="Chiller Van Rental in Al Barsha | From AED 250/Day | Chiller Fleet" />
        <meta name="twitter:description" content="Chiller van rental in Al Barsha from our local branch — standard roof vans cleared for hotel basements and Mall of the Emirates loading bays. On site in 15 to 30 minutes." />
      </Helmet>

      {chillerVanAlBarshaSections.map(renderSection)}
    </>
  );
};

export default ChillerVanForRentInAlBarsha;
